import React, { forwardRef } from "react";
import "./ItemDate.css";
import TauriImage from "../../../../../TauriImage/TauriImage";
import { accountMapping, sessionType } from "../../../../../../visualizations/visualizations";

const getToday = () => {
    const now = new Date();
    now.setHours(0, 0, 0, 0); // Ensures time doesn't affect the date
    return now.toLocaleDateString("en-CA");
};

const ItemDate = forwardRef(({ sessions, sessTime, onDateClick, hoveredAccount, showUnplanned, style }, ref) => {
    const today = getToday();

    const statusIcon = {
        0: "/Images/material-symbols--pending-actions.svg",
        1: "/Images/material-symbols--check.svg",
        2: "/Images/akar-icons--person-cross.svg",
        3: "/Images/mdi--hourglass.svg",
        4: "/Images/mdi--check-decagram.svg",
        5: "/Images/material-symbols--check-advanced.svg"
    };

    // Normalize to 'en-CA' format
    const formattedDates = sessions.map(session => ({
        ...session,
        formatted: new Date(session.SessionDate).toLocaleDateString("en-CA")
    }));

    const hasToday = formattedDates.find(d => d.formatted === today);
    const pastDates = formattedDates.filter(d => new Date(d.formatted) < new Date(today));
    const futureDates = formattedDates.filter(d => new Date(d.formatted) > new Date(today));

    const formatDisplayDate = (date) =>
        new Date(date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });

    return (
        <div ref={ref} className="item-date-popup" style={style}>
            {pastDates.map((date, index) => (
                <div
                    key={index}
                    className={`item-date-row item-date-details ${index % 2 === 0 ? '' : 'striped-color'}`}
                    onClick={() => onDateClick?.(date, sessionType.PastDue)}
                >
                    {date?.Joint &&
                        <TauriImage
                            localImage="/Images/mdi--handshake-outline.svg"
                            alt={`status-${date?.Status}`}
                            className="idp-icon"
                        />
                    }
                    <TauriImage
                        localImage={statusIcon[date?.Status]}
                        alt={`status-${date?.Status}`}
                        className="idp-icon"
                    />
                    <span>{formatDisplayDate(date.SessionDate)}</span>
                </div>
            ))}
            <div className={`item-date-row item-date-header ${hasToday ? 'has-today' : ''}`}>
                {hasToday ? (
                    <>
                        {hasToday?.Joint && (
                            <TauriImage
                                localImage="/Images/mdi--handshake-outline.svg"
                                alt={`status-${hasToday?.Status}`}
                                className="idp-icon"
                            />
                        )}

                        <TauriImage
                            localImage={statusIcon[hasToday?.Status]}
                            alt={`status-${hasToday?.Status}`}
                            className="idp-icon"
                        />
                    </>
                ) : (
                    <TauriImage
                        localImage="/Images/f7--calendar-today.svg"
                        alt="icon"
                        className="idp-icon"
                        color="#000"
                    />
                )}
                <span>{hasToday ? `Today, ${sessTime}` : "No Schedule Today"}</span>
                {(!hasToday && hoveredAccount?.Type === accountMapping.Agent) &&
                    <TauriImage
                        localImage="/Images/flat-color-icons--plus.svg"
                        className={"inci-icon"}
                        onClick={showUnplanned}
                        alt="brand-icon"
                    />
                }
            </div>

            <div className="item-date-divider" />

            {futureDates.length > 0 ? (
                futureDates.map((date, index) => (
                    <div
                        key={index}
                        className={`item-date-row item-date-details ${index % 2 === 0 ? '' : 'striped-color'}`}
                        onClick={() => onDateClick?.(date, sessionType.Advanced)}
                    >
                        {date?.Joint && (
                            <TauriImage
                                localImage="/Images/mdi--handshake-outline.svg"
                                alt="jointcall"
                                className="idp-icon"
                            />
                        )}

                        <TauriImage
                            localImage={statusIcon[date?.Status]}
                            alt={`status-${date?.Status}`}
                            className="idp-icon"
                        />
                        <span>{formatDisplayDate(date.SessionDate)}</span>
                    </div>
                ))
            ) : (
                <div className="item-date-row">
                    <span>No Future Schedule</span>
                </div>
            )}
        </div>
    );
});

export default ItemDate;
